import store from '@/store'

/**
 * Current copilot PIN staff id, or undefined when anonymous / no session.
 */
export function getCurrentStaffId() {
	return store.state.copilot?.currentStaff?.id || undefined
}

/**
 * Merge optional staffId from the active PIN session into an API payload.
 * Does not overwrite an explicit staffId already on the payload.
 * Does not inject into apiRequest globally — call only from operational repositories.
 */
export function withCurrentStaff(payload = {}) {
	const body = payload && typeof payload === 'object' ? { ...payload } : {}
	if (body.staffId) {
		return body
	}
	const staffId = getCurrentStaffId()
	if (staffId) {
		body.staffId = staffId
	}
	return body
}
